<!--
  ~ Copyright (c) 2019 Signum+ Software & Facility GmbH
  ~ Author: jahn@signum-plus.at
  -->

<ng-container *ngIf="model">
  <ng-container *ngFor="let item of model.items" [kitComponent]="item"></ng-container>
</ng-container>